import React from 'react';
import { Button } from '@mui/material';
import { MODAL_STYLES, mergeModalStyles } from '../../utils/modalStyles';

/**
 * Standardized Button component for modals
 * Ensures consistent height, padding, and styling across all modal buttons
 */
const ModalButton = ({ variant = 'contained', color = 'primary', children, sx, ...props }) => {
  return (
    <Button
      variant={variant}
      color={color}
      sx={mergeModalStyles(MODAL_STYLES.button, sx)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ModalButton;
